import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';
import Modal from 'react-modal';

import device from '../../config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 3%;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }
  }

  div {
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }

  h2 {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 55%;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  color: var(--greenDark);
  margin: 10px;

  h3 {
    padding: 1px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.9rem;
  }

  h3.title {
    justify-content: space-between;
    align-items: center;
    margin: -1%;
    padding-right: 1%;
  }

  p {
    font-size: 1.7rem;

    @media (max-width: 426px) {
      font-size: larger;
    }
  }
`;

export const Tbody = styled.tbody`
  margin: 5px 0;
  width: 100%;

  td.status {
    color: ${props => (props.statusColor ? props.statusColor : '#20303d')};
  }
`;

export const Table = styled.table`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid rgba(207, 207, 207, 0.8);
  padding: 10px 0;
  color: var(--greenDark);
  margin: 20px 40px;
  font-size: 0.8rem;

  #barcodeNumber {
    cursor: pointer;
    color: var(--blueUrl);
    background-color: var(--white);
    border: 0;

    &:hover {
      color: ${darken(0.2, '#94d3f3')};
    }
  }

  thead tr {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    color: var(--blueDark);
    font-weight: bold;
    margin-bottom: 1%;
    text-align: center;
    border: 0;

    @media (max-width: 426px) {
      display: flex;
      flex-direction: column;
    }
  }

  svg {
    color: var(--yellowDark);
    margin-right: 5px;
    cursor: pointer;
  }

  tr {
    display: flex;
    justify-content: space-between;
    text-align: center;

    border-top: 1px solid rgba(207, 207, 207, 0.8);

    @media (max-width: 426px) {
      display: flex;
      flex-direction: column;
    }
  }

  td {
    margin: 5px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h2 {
    text-align: center;
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid #767676;
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: 0 30px;

    svg {
      cursor: pointer;
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
`;

export const InfoRest = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  margin: 10px;

  p {
    font-size: 1rem;
  }

  button {
    color: var(--blueDark);
    &:hover {
      color: ${darken(0.2, '#1c2156')};
    }
  }
`;

export const ModalStyle = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--white);
  border: 1px solid var(--gray);
  border-radius: 10px;
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  text-align: center;

  svg {
    position: relative;
    left: calc(15%);
    top: -25px;
    cursor: pointer;

    @media (max-width: 1500px) {
      left: calc(13%);
      top: 0;
    }
    @media (max-width: 1024px) {
      top: -5px;
      left: calc(-2%);
      width: 40px;
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  padding: 5px;
  text-align: justify;

  div {
    width: 70%;
    margin: 5px;

    font-size: 0.9rem;
  }

  strong {
    margin: 5px;
  }

  button {
    margin: 20px 0 30px 0;
    height: 25px;
    background: var(--yellowDark);
    width: 30%;
    color: var(--blueDark);
    border: 0;
    border-radius: 7px;
    font-size: 14px;
    font-weight: bold;
    transition: background 0.2s;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.2);

    @media ${device.mobileMinTabMax} {
      width: auto;
      padding: 0 10px;
    }
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
